// @flow

import React from 'react';
import { isMobile } from 'react-device-detect';
import AppNav from './../app-nav';
import { NativeAppBannerMobile } from '../shared/native-app-banner';

type Props = {
  children: any,
  className: string,
  hideBanner?: boolean
}

const AuthLayout = ({ children, className, hideBanner }: Props) => {
  return (
    <div className={`${className} ${isMobile ? 'has-app-banner' : ''}`}>
      <AppNav />
      <div className='container is-fluid page-container'>
        <div className='auth-page'>
          {children}
        </div>
      </div>
      {!hideBanner &&
      <NativeAppBannerMobile />
      }
    </div>
  );
};

export default AuthLayout;


// WEBPACK FOOTER //
// ./src/components/layouts/AuthLayout.js